import type { SxProps, Theme } from '@mui/material/styles';

export const cellContainerSx: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  overflow: 'visible',
};

export const getCellStackSx = (paddingLeft: string | number): SxProps<Theme> => ({
  width: '100%',
  pl: paddingLeft,
  pr: '0.75rem',
  py: '0.5rem',
  minWidth: 0,
});

export const groupLabelSx: SxProps<Theme> = {
  fontSize: '0.875rem',
  fontWeight: 600,
  color: '#504E5A',
  whiteSpace: 'nowrap',
  flexShrink: 0,
  mr: '0.75rem',
};

export const groupRowChipSx: SxProps<Theme> = {
  minWidth: 'max-content !important',
  whiteSpace: 'nowrap',
  flexShrink: 0,
  padding: '0.25rem 0.75rem !important',
  '& .MuiChip-label': {
    textTransform: 'none !important',
    minWidth: 'auto !important',
    overflow: 'visible',
  },
};

export const getArrowButtonSx = (useSvgIcons: boolean, chipBgColor: string): SxProps<Theme> => ({
  p: 0,
  color: useSvgIcons ? chipBgColor : '#807D93',
  flexShrink: 0,
  ...(useSvgIcons && {
    '& svg': {
      width: '1.25rem',
      height: '1.25rem',
    },
  }),
});

export const getArrowIconSx = (isExpanded: boolean | undefined): SxProps<Theme> => ({
  fontSize: '1.4rem',
  transform: isExpanded ? 'rotate(180deg)' : 'none',
  transition: 'transform 0.2s ease',
});
